import {ColorValue, TextStyle} from 'react-native';
import {RoundedBtnDescriberProps} from 'src/components/elements/buttonDescriptor/DescriptorType';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {ButtonType} from 'src/components/elements/RoundedButton';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';

export function roundedBtnColorDescriptor(props: RoundedBtnDescriberProps): {
  [index: string]: ColorValue;
} {
  const disabledColor = Styles.lightGray;
  const buttonColor = props.disabled
    ? disabledColor
    : props.color || Styles.primaryColor;
  let fillColor = Styles.primaryColor;
  let textColor = Styles.white;

  if (props.buttonType === 'outline') {
    fillColor = Styles.transparent;
    textColor = props.disabled
      ? disabledColor
      : props.color || Styles.primaryColor;
  } else {
    fillColor = props.disabled
      ? disabledColor
      : props.color || Styles.primaryColor;
    textColor = Styles.white;
  }
  return {fillColor, textColor, buttonColor};
}

export function roundAppButtonSolidTextStyle(_disabled: boolean): TextStyle {
  return null;
}

export function roundAppButtonOutlineTextStyle(_disabled: boolean): TextStyle {
  return null;
}

export function checkRoundedBtnColor(): string {
  return Styles.Colors.Refive.activeFooterBlue;
}

export function getSaveBtnManageAccount(
  handleSave,
  checkDisabled: () => boolean,
) {
  return (
    <RoundedAppButton
      buttonContainerStyle={{
        right: Styles.Spacing.m3,
        bottom: Styles.Spacing.m3,
        position: 'absolute',
      }}
      buttonViewStyle={{height: 46}}
      textStyle={{
        fontSize: Styles.Fonts.f1,
        fontFamily: Styles.FontFamily.figtreeRegular,
        marginHorizontal: Styles.Spacing.m2,
      }}
      isDisabled={checkDisabled()}
      inActiveButtonViewStyle={{
        backgroundColor: Styles.Colors.PayNew.darkHuesBase04,
        marginHorizontal: Styles.Spacing.m2,
        height: 46,
      }}
      inActiveTextStyle={{fontSize: Styles.Fonts.f1}}
      buttonType={RoundedAppButtonType.Solid}
      titleText={Localized.Buttons.save}
      onPress={handleSave}
      accessibilityLabelValue={Localized.Buttons.save}
      aria-label={Localized.Buttons.save}
    />
  );
}

export function getTertiaryCTATextStyle(): TextStyle {
  return null;
}

export function buttonTextFontFamily(): string {
  return Styles.FontFamily.figtreeRegular;
}
export function redeemRewardRoundedBtnColor(_type?: ButtonType): string {
  return Styles.Colors.PayNew.primary01;
}

export function redeemRewardIconColor(): string {
  return Styles.Colors.Canteen.darkGreen;
}

export default {
  roundedBtnColorDescriptor,
  roundAppButtonSolidTextStyle,
  roundAppButtonOutlineTextStyle,
  checkRoundedBtnColor,
  getSaveBtnManageAccount,
  getTertiaryCTATextStyle,
  buttonTextFontFamily,
  redeemRewardRoundedBtnColor,
  redeemRewardIconColor,
};
